export default __webpack_public_path__ + "static/img_welfare_4-371fc7f75237171dfc556113afef07ec.jpg";